/// <reference types="chrome"/>

import {
  ExtensionDashboardMessage,
  ExtensionDashboardMessageCheckPermissionsResponse,
  ExtensionDashboardMessageType,
  ExtensionDashboardResponse,
} from "tf-api-client";

class ExtensionService {
  public static isInstalled() {
    return typeof chrome !== "undefined" && chrome.runtime !== undefined;
  }

  public static async openBlockedHrefForTab() {
    await ExtensionService.sendMessage({
      type: ExtensionDashboardMessageType.OpenBlockedHrefForTab,
    });
  }

  public static async openBrowserExtensionSettings() {
    await ExtensionService.sendMessage({
      type: ExtensionDashboardMessageType.OpenBrowserExtensionSettings,
    });
  }

  public static async allowHostname(hostname: string) {
    await ExtensionService.sendMessage({
      type: ExtensionDashboardMessageType.AllowHostname,
      hostname,
    });
  }

  public static async reloadSecurityPolicies() {
    await ExtensionService.sendMessage({
      type: ExtensionDashboardMessageType.ReloadConfig,
    });
  }

  public static async checkPermissions(): Promise<ExtensionDashboardMessageCheckPermissionsResponse> {
    const response =
      await ExtensionService.sendMessage<ExtensionDashboardMessageCheckPermissionsResponse>(
        {
          type: ExtensionDashboardMessageType.CheckPermissions,
        },
      );

    return response!;
  }

  public static async hasAllAccess(): Promise<boolean> {
    const permissions = await ExtensionService.checkPermissions();
    return Object.values(permissions).every((value) => value);
  }

  public static async exportLogs() {
    await ExtensionService.sendMessage({
      type: ExtensionDashboardMessageType.ExportLogs,
    });
  }

  public static async sendMessage<T extends ExtensionDashboardResponse>(
    data: ExtensionDashboardMessage,
  ): Promise<T | undefined> {
    const extensionId = localStorage.getItem("extensionId");

    if (typeof chrome !== "undefined" && chrome.runtime && extensionId) {
      return (await chrome.runtime.sendMessage(extensionId, data)) as T;
    } else {
      console.warn(
        "Extension runtime is not available or extensionId is missing.",
      );
    }
  }
}

export default ExtensionService;
